/**
 * Group counterpart of ChatInfo.jsx, for the SM/MD/XS Drawer mounts in Inbox.jsx (WhatsApp
 * Groups plan follow-up, 2026-09-26). ChatInfo.jsx is a 2,400+ line, entirely 1:1-contact-
 * specific component (contactInfo, labels, notes, sticky agent, none of which apply to a group
 * per this feature's own decision #2/#4) -- forking isGroup through it would be exactly the
 * kind of risky, invasive change this whole feature has consistently avoided (see
 * baileysGroupInboundHandler.js's own header comment on why a parallel file beats threading a
 * branch through a large existing one). This is that parallel file instead: a thin drawer
 * shell (same header shape as ChatInfo.jsx's own -- title + close button) around
 * GroupDescriptionSection, the exact same component the LG/XL persistent rail
 * (ChatInfoRail.jsx) already uses for its own "Group Description" panel -- reused via that
 * file's named export, not duplicated a second time.
 */
import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { slimScrollbarSx } from "../../utils/scrollbarStyles";
import { GroupDescriptionSection } from "./ChatInfoRail";

function GroupInfoDrawer({ groupId, onClose, showCloseButton = false }) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "17.6px 17.6px 0 17.6px",
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          flexShrink: 0,
        }}
      >
        <Typography variant="h6" sx={{ color: (theme) => theme.palette.text.primary, fontWeight: 700 }}>
          Group Info
        </Typography>
        {showCloseButton && onClose && (
          <IconButton onClick={onClose} sx={{ color: (theme) => theme.palette.text.primary }}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <Box sx={{ flex: 1, overflowY: "auto", overflowX: "hidden", minHeight: 0, ...slimScrollbarSx }}>
        <GroupDescriptionSection groupId={groupId} />
      </Box>
    </>
  );
}

export default GroupInfoDrawer;
